export const API_SET_CREATE = '/tao-bo-thiet-bi'
export const API_SET_LST = '/ho-so-bo-thiet-bi'